import {
  Button,
  Card,
  CardColors,
  Heading,
  HeadingColors,
  HeadingVariants,
  Text,
} from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { useMobileNavAnnouncement } from './useMobileNavAnnouncement'

// The mobile counterpart to the desktop sidebar coachmark. Self-gating: the
// hook decides whether this user, on this viewport, with this flag state,
// should see anything at all, so mounting it is unconditional at the call site.
export const MobileNavAnnouncementCard = () => {
  const {
    open,
    eyebrow,
    title,
    body,
    actionLabel,
    onAction,
    onTemporaryClose,
  } = useMobileNavAnnouncement()

  if (!open) return null

  return (
    <Card
      color={CardColors.PRIORITY}
      childrenClassName="flex flex-col gap-4"
      dismissible
      onClose={onTemporaryClose}
    >
      <header className="flex flex-col gap-1">
        <Text variant={TypographyStyles.EYEBROW} color={TextColors.MUTED}>
          {eyebrow}
        </Text>
        {/* pr-6 keeps the title clear of the dismiss icon, which the Card
            positions absolutely in the same top-right corner. */}
        <Heading
          variant={HeadingVariants.H3}
          color={HeadingColors.HEADER_TEXT}
          className="pr-6"
        >
          {title}
        </Heading>
      </header>

      <Text variant={TypographyStyles.BODY_SM} color={TextColors.DEFAULT}>
        {body}
      </Text>

      <div className="flex">
        <Button onClick={onAction}>{actionLabel}</Button>
      </div>
    </Card>
  )
}
